/**
 * Código visual de una tarea (folio custom o OT-{displayNumber}).
 * numeroTarea solo como último fallback ancestral.
 */
export function getTaskVisualLabel(task: {
  numeroCustom?: string | null;
  displayNumber?: string | null;
  numeroTarea?: number | string | null;
  titulo?: string | null;
}): string {
  if (task?.numeroCustom) {
    return String(task.numeroCustom);
  }
  if (task?.displayNumber != null && String(task.displayNumber).trim() !== '') {
    return `OT-${task.displayNumber}`;
  }
  if (task?.numeroTarea != null && task.numeroTarea !== '') {
    return `OT-${task.numeroTarea}`;
  }
  if (typeof task?.titulo === 'string' && task.titulo.trim()) {
    return task.titulo;
  }
  return '';
}

/** Folio para reportes: numeroCustom o "OT-numeroTarea" como fallback. */
export function getTaskReportFolio(task: {
  numeroCustom?: string | null;
  numeroTarea?: number | string | null;
  displayNumber?: string | null;
}): string {
  if (task?.numeroCustom && String(task.numeroCustom).trim()) {
    return String(task.numeroCustom).trim();
  }
  if (task?.numeroTarea != null && String(task.numeroTarea).trim()) {
    return `OT-${String(task.numeroTarea).trim()}`;
  }
  if (task?.displayNumber != null && String(task.displayNumber).trim()) {
    return `OT-${String(task.displayNumber).trim()}`;
  }
  return '';
}

/** Compatibilidad legacy. Las secuencias v2 se identifican por customSequenceId. */
export function detectRootFolioPrefix(numeroCustom?: string | null): string | null {
  if (!numeroCustom) return null;
  const match = String(numeroCustom)
    .trim()
    .match(/^([A-Za-z0-9]+)-(\d+)(?:\.|$)/);
  return match?.[1] ? match[1].toUpperCase() : null;
}

/** Correlativo raíz final para folios legacy o componibles, incluyendo hijos. */
export function detectRootFolioNumber(numeroCustom?: string | null): number | null {
  if (!numeroCustom) return null;
  const match = String(numeroCustom).trim().match(/-(\d+)(?:\.\d+)*$/);
  if (match) return Number(match[1]);
  const numberOnly = String(numeroCustom).trim().match(/^(\d+)(?:\.\d+)*$/);
  return numberOnly ? Number(numberOnly[1]) : null;
}
